<script setup lang="ts">
import AdminEcosystemSidebar from '~/components/layout-admin/AdminEcosystemSidebar.vue'
import AdminSidebar from '~/components/layout-admin/AdminSidebar.vue'
</script>

<template>
  <UDashboardGroup>
    <a
      href="#main-content"
      class="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-white focus:text-black focus:rounded-md focus:shadow-lg"
    >
      Aller au contenu principal
    </a>
    <AdminEcosystemSidebar current="bot-riven" />
    <AdminSidebar />

    <div class="flex-1 flex flex-col h-full overflow-hidden relative">
      <UMain id="main-content" class="px-6 md:px-10 py-8 grow space-y-8 overflow-y-overlay">
        <slot />
      </UMain>
    </div>
  </UDashboardGroup>
</template>
